import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import { defineComponent as _defineComponent } from 'vue';
import { useCurrency } from '@vsf-enterprise/commercetools';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import { useUpsellProducts } from '@/composables/attraqt/useAttraqtIntegration';
import { useCart } from '~/composables/useCart';
import useRightPath from '~/composables/useRightPath';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import { createObjectFromNumbers } from '~/utils/CreateObjectFromNumbers';
export default /*#__PURE__*/_defineComponent({
  __name: 'UpSellProduct',
  props: {
    product: {
      type: Object,
      required: true
    },
    widgetId: {
      type: String,
      required: true
    },
    recommendationId: {
      type: String,
      required: true
    },
    index: {
      type: Number
    },
    showPrice: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var _product$value, _product$value$_id, _product$value2, _product$value2$_id;
    var props = __props;
    var _useCart = useCart(),
      cart = _useCart.cart,
      addItem = _useCart.addItem;
    var route = useRoute();
    var router = useRouter();
    var product = computed(function () {
      return props.product.product;
    });
    var taxRate = computed(function () {
      var _cart$value, _cart$value$taxedPric, _cart$value$taxedPric2, _cart$value$taxedPric3;
      return (_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : (_cart$value$taxedPric = _cart$value.taxedPrice) === null || _cart$value$taxedPric === void 0 ? void 0 : (_cart$value$taxedPric2 = _cart$value$taxedPric.taxPortions) === null || _cart$value$taxedPric2 === void 0 ? void 0 : (_cart$value$taxedPric3 = _cart$value$taxedPric2[0]) === null || _cart$value$taxedPric3 === void 0 ? void 0 : _cart$value$taxedPric3.rate;
    });
    var getCurrency = useCurrency().currency.value;
    var priceInCents = computed(function () {
      return Number(product.value.price.toFixed(2));
    });
    var priceInEuro = computed(function () {
      return Number((product.value.price / 100).toFixed(2));
    });
    var upsellProducts = useUpsellProducts();
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useUiState = useUiState(),
      toggleCartSidebar = _useUiState.toggleCartSidebar;
    var gtmEcommerceItems = {
      value: priceInEuro.value,
      value_in_cents: priceInCents.value,
      items: [{
        item_id: "SKU_".concat((_product$value = product.value) === null || _product$value === void 0 ? void 0 : (_product$value$_id = _product$value._id) === null || _product$value$_id === void 0 ? void 0 : _product$value$_id.original_id),
        item_sku: (_product$value2 = product.value) === null || _product$value2 === void 0 ? void 0 : (_product$value2$_id = _product$value2._id) === null || _product$value2$_id === void 0 ? void 0 : _product$value2$_id.original_id,
        item_name: product.value.title,
        price: priceInEuro.value,
        price_in_cents: priceInCents.value,
        item_location: 'upsell_product',
        currency: getCurrency
      }]
    };
    var onAddToCart = function onAddToCart() {
      var _product$value3, _product$value3$_id;
      var productData = {
        sku: (_product$value3 = product.value) === null || _product$value3 === void 0 ? void 0 : (_product$value3$_id = _product$value3._id) === null || _product$value3$_id === void 0 ? void 0 : _product$value3$_id.original_id,
        name: product.value.title
      };
      addItem({
        product: {
          sku: props.product.id
        },
        quantity: 1
      });
      upsellProducts.sendUpsellClick(productData, props.recommendationId, props.widgetId, props.index + 1);
      $trackers.gtm.pushEvent('add_to_cart', {
        event_category: 'ecommerce',
        event_action: 'add',
        event_label: props.product.product.title,
        event_name: 'add_to_cart',
        total_items: 1,
        source_id: props.widgetId,
        page_url: route.fullPath,
        ecommerce: gtmEcommerceItems
      });
    };
    var isGlobalPrice = function isGlobalPrice(taxRate) {
      return taxRate === 0;
    };
    var isDiscounted = function isDiscounted(taxRate) {
      return getFullPrice(taxRate) - getDiscountedPrice(taxRate) !== 0;
    };
    var getFullPrice = function getFullPrice(taxRate) {
      if (isGlobalPrice(taxRate)) {
        return product.value.displayVariantPriceGlobalFull || product.value.displayVariantPriceGlobal;
      } else {
        return product.value.displayVariantPriceEUFull || product.value.displayVariantPriceEU;
      }
    };
    var getDiscountedPrice = function getDiscountedPrice(taxRate) {
      if (isGlobalPrice(taxRate)) {
        return product.value.displayVariantPriceGlobal;
      } else {
        return product.value.displayVariantPriceEU;
      }
    };
    var productPageLink = function productPageLink() {
      var _product$value4;
      return app.localePath(getProductPath({
        slug: (_product$value4 = product.value) === null || _product$value4 === void 0 ? void 0 : _product$value4.url
      }));
    };
    var handleRedirect = function handleRedirect() {
      toggleCartSidebar();
      router.push(productPageLink());
    };
    return {
      __sfc: true,
      props: props,
      cart: cart,
      addItem: addItem,
      route: route,
      router: router,
      product: product,
      taxRate: taxRate,
      getCurrency: getCurrency,
      priceInCents: priceInCents,
      priceInEuro: priceInEuro,
      upsellProducts: upsellProducts,
      app: app,
      $trackers: $trackers,
      getProductPath: getProductPath,
      toggleCartSidebar: toggleCartSidebar,
      gtmEcommerceItems: gtmEcommerceItems,
      onAddToCart: onAddToCart,
      isGlobalPrice: isGlobalPrice,
      isDiscounted: isDiscounted,
      getFullPrice: getFullPrice,
      getDiscountedPrice: getDiscountedPrice,
      productPageLink: productPageLink,
      handleRedirect: handleRedirect,
      PriceDisplay: PriceDisplay,
      AzButton: AzButton,
      AzIcon: AzIcon,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom,
      createObjectFromNumbers: createObjectFromNumbers
    };
  }
});